import store from '@/store'

function packCluster(cluster) {
  const columnEnds = [];
  let maxColumns = 0;

  for (let i = 0; i < cluster.length; i++) {
    const session = cluster[i];
    let column = 0;
    while (column < columnEnds.length && columnEnds[column] > session.start_time_timestamp) {
      column++;
    }
    if (column === columnEnds.length) {
      columnEnds.push(session.end_time_timestamp);
    } else {
      columnEnds[column] = session.end_time_timestamp;
    }
    session.column = column;
    if (column + 1 > maxColumns) maxColumns = column + 1;
  }

  for (let i = 0; i < cluster.length; i++) {
    cluster[i].columns = maxColumns;
    cluster[i].overlaps = maxColumns;
  }
}

function assignColumns(sessions) {
  const byRoom = {};
  for (let i = 0; i < sessions.length; i++) {
    const session = sessions[i];
    session.column = 0;
    session.columns = 1;
    session.overlaps = 1;
    const key = session.day_id + ':' + session.room_id;
    if (!byRoom[key]) byRoom[key] = [];
    byRoom[key].push(session);
  }

  Object.keys(byRoom).forEach(key => {
    const roomSessions = byRoom[key].slice().sort((a, b) => {
      if (a.start_time_timestamp !== b.start_time_timestamp) {
        return a.start_time_timestamp - b.start_time_timestamp;
      }
      return a.end_time_timestamp - b.end_time_timestamp;
    });

    let cluster = [];
    let clusterEnd = 0;

    for (let i = 0; i < roomSessions.length; i++) {
      const session = roomSessions[i];
      if (cluster.length && session.start_time_timestamp >= clusterEnd) {
        packCluster(cluster);
        cluster = [];
        clusterEnd = 0;
      }
      cluster.push(session);
      if (session.end_time_timestamp > clusterEnd) {
        clusterEnd = session.end_time_timestamp;
      }
    }
    if (cluster.length) packCluster(cluster);
  });
}

export function addAttributes(sessions) {
  for (let i = 0; i < sessions.length; i++) {
    let session = sessions[i];
    let matching = true;
    if (store.state.filter.session_group.length && !store.state.filter.session_group.includes(session.session_group_id)) {
      matching = false;
    }
    if (store.state.filter.session_type.length && !store.state.filter.session_type.includes(session.session_type_id)) {
      matching = false;
    }
    if (store.state.filter.room.length && !store.state.filter.room.includes(session.room_id)) {
      matching = false;
    }
    session.matching = matching;
    if (session.type === null) {
      session.type = { value: { color: '#000000', background: '#ffffff' }};
    }
  }
  assignColumns(sessions);
  return sessions;
}
